/**
 * Generate a CSS selector for an element (Option B: generated from DOM attributes).
 * Used to identify elements for sync - master captures, servant replays.
 */
export function getSelectorForElement(el) {
    if (!el || !el.getAttribute || el === document.body) return null;

    if (el.id && /^[a-zA-Z][\w-]*$/.test(el.id)) {
        return `#${el.id}`;
    }

    const href = el.getAttribute('href');
    if (href != null && el.tagName === 'A') {
        return `a[href="${escapeSelectorAttr(href)}"]`;
    }

    const dataSyncId = el.getAttribute('data-sync-id');
    if (dataSyncId) {
        return `[data-sync-id="${escapeSelectorAttr(dataSyncId)}"]`;
    }

    const role = el.getAttribute('role');
    const ariaLabel = el.getAttribute('aria-label');
    if (role && ariaLabel) {
        return `[role="${escapeSelectorAttr(role)}"][aria-label="${escapeSelectorAttr(ariaLabel)}"]`;
    }

    return getPathSelector(el);
}

function escapeSelectorAttr(str) {
    return String(str).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

function getPathSelector(el) {
    const path = [];
    let currentEl = el;

    while (currentEl && currentEl !== document.body) {
        let part = currentEl.tagName.toLowerCase();

        if (currentEl.id && /^[a-zA-Z][\w-]*$/.test(currentEl.id)) {
            path.unshift(`#${currentEl.id}`);
            break;
        }

        if (currentEl.className && typeof currentEl.className === 'string') {
            const classes = currentEl.className.trim().split(/\s+/).filter((c) => c && !c.startsWith('css-'));
            if (classes.length > 0) {
                part += '.' + classes.slice(0, 3).join('.');
            }
        }

        const parent = currentEl.parentElement;
        if (parent) {
            const tagName = currentEl.tagName;
            const siblings = Array.from(parent.children).filter((c) => c.tagName === tagName);
            if (siblings.length > 1) {
                const idx = siblings.indexOf(currentEl) + 1;
                part += `:nth-of-type(${idx})`;
            }
        }

        path.unshift(part);
        currentEl = parent;
    }

    return path.length ? path.join(' > ') : null;
}

/**
 * Find an element by the generated selector. Returns null if not found.
 */
export function findElementBySelector(selector) {
    if (!selector || typeof selector !== 'string') return null;
    try {
        const root = document.getElementById('app-root');
        const scope = root || document;
        const el = scope.querySelector(selector);
        return el || document.querySelector(selector);
    } catch {
        return null;
    }
}
